"use client"

import type { FAQItem } from "#modules/general/faq/faqCollection"

import React, { useState } from "react"

import { twMerge } from "#lib/twMergeConfig"
import SvgArrowDown from "#svgs/semantic icons/ArrowDown"

export function FaqDisplay({ faqItem }: { faqItem: FAQItem }) {
  const [visible, setVisible] = useState(false)
  return (
    <article className={"group cursor-pointer py-4 xl:py-8"} onClick={() => setVisible(old => !old)}>
      <div className={"flex w-full items-center justify-between"}>
        <h3 className={twMerge("my-1 text-bg font-bold transition-colors group-hover:text-gold-130 sm:text-bg xl:mb-3 xl:text-ih6", visible && "text-gold-130")}>
          {faqItem.question}
        </h3>
        <div
          className={twMerge(
            "relative ml-5 mt-2 after:absolute after:left-1/2 after:top-1/2 after:-z-10 after:block after:size-12 after:-translate-x-1/2 after:-translate-y-1/2 after:rounded-full after:transition-colors hover:after:bg-gray-100 xl:mt-0",
            !visible && "xl:mt-8",
          )}>
          <SvgArrowDown
            className={twMerge("size-4 shrink-0 transition-[transform,color] group-hover:text-gold-130 xl:size-5", !visible && "-rotate-90", visible && "text-gold-130")}
          />
        </div>
      </div>
      <div className={"relative"}>
        <MockTextDisplay text={faqItem.answer} visible={visible} />
        {/* Real text */}
        <p
          className={twMerge(
            "m-0 overflow-hidden text-nm opacity-0 transition-all duration-500 xl:pr-8 xl:text-[18px]",
            visible ? "mb-2 mt-4 max-h-96 opacity-100" : "max-h-0 text-gray-50 xl:mb-2 xl:max-h-8",
          )}>
          {faqItem.answer}
        </p>
      </div>
    </article>
  )
}

// Only for animation purposes to animate and display line-clamp properly
function MockTextDisplay({ text, visible }: { text: string; visible: boolean }) {
  return (
    <p
      className={twMerge(
        "absolute mb-2 hidden max-h-10 overflow-hidden pr-8 text-[18px] text-gray-50 opacity-100 transition-opacity delay-150 xl:line-clamp-1",
        visible && "opacity-0",
      )}>
      {text}
    </p>
  )
}
